
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { UserService } from './user/user.service';
import { User } from './user/user';
import { UtilityService } from  './utility.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {  
title = 'EnteroInvoicePO';

  public changePassPopup ="none";
  private _opened: boolean = true;
  changePasswordForm: FormGroup;
  // changepass = new User();
  changepass : any = {}
  submitted = false;
  invalispass = false;

	  private _toggleSidebar() {
		this._opened = !this._opened;
	  }
	  
	  public CurrentUser : any;
  constructor(
    public auth: AuthService, 
    private router: Router,
    private formBuilder: FormBuilder, 
    private util:UtilityService, 
    private userService : UserService) { }

  ngOnInit(){	  
		
		// this.changePasswordForm = this.formBuilder.group({			
    //   oldpassword: [this.changepass.oldpassword,[Validators.required, Validators.required]],
    //   newpassword: [this.changepass.newpassword,[Validators.required, Validators.required]],
    //   confirmpassword: [this.changepass.confirmpassword,[Validators.required, Validators.required]]
    // });	
	 // this.getUsersinfo();
  }

  get f() {
    return this.changePasswordForm.controls
    }
  
  logout() {
    this.auth.logout();
    this.router.navigate(['login']);
  }

  changepassword() {
    this.changePassPopup = "block" 
    //this.auth.logout();
    //this.router.navigate(['login']);
  }

  closechangePassModal(){
    this.changePassPopup = "none"
  }

  onSubmit(newpass,confirmpass): void {

    this.validPassword(newpass,confirmpass);
    this.submitted = true;
    
    // stop here if form is invalid
    // if (this.stateForm.invalid) {
    //     return this.util.showError("Please enter required fields.");		
    // }
    
  }
  validPassword(newpass,confirmpass){
    if(newpass == confirmpass){
      this.Changepassword();
    }else{
      this.invalispass = true;
      // alert("Confirm Password and New Password does not match..");
    }
    
  }

  Changepassword(){
   // console.log(this.changepass);
    this.changepass.id = this.auth.currentUserValue.userid;
    this.userService.Changepassword(this.changepass)
        .subscribe(() =>
		{
            this.util.showSuccess("Password changed successfully.");
            this.closechangePassModal();
            this.auth.logout();
            this.router.navigate(['login']);
      });
  }

}
